import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../api";
import { ADMIN_PATH } from "../../config";

type Post = {
    _id: string;
    title: string;
    slug: string;
    published: boolean;
    createdAt: string;
};

const Dashboard = () => {
    const [posts, setPosts] = useState<Post[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchPosts = () => {
        api.getAllPosts().then((data) => {
            setPosts(data);
            setLoading(false);
        });
    };

    useEffect(() => { fetchPosts(); }, []);

    const handleDelete = async (id: string) => {
        if (!confirm("Delete this post?")) return;
        await api.deletePost(id);
        fetchPosts();
    };

    const handleTogglePublish = async (post: Post) => {
        await api.updatePost(post._id, { ...post, published: !post.published });
        fetchPosts();
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate(`${ADMIN_PATH}/login`);
    };

    return (
        <div className="min-h-screen bg-(--bg-main) px-8 py-10 max-w-3xl mx-auto">
            <header className="flex justify-between items-center mb-12">
                <h1 className="font-is text-4xl">dashboard.</h1>
                <div className="flex gap-3">
                    <Link
                        to={`${ADMIN_PATH}/new`}
                        className="font-inter text-sm px-4 py-2 rounded-full bg-[#F4611D] text-white hover:bg-[#d94e0f] transition-colors"
                    >
                        + new post
                    </Link>
                    <button
                        onClick={handleLogout}
                        className="font-inter text-sm px-4 py-2 rounded-full border border-neutral-300 text-neutral-500 hover:border-neutral-400 transition-colors cursor-pointer"
                    >
                        sign out
                    </button>
                </div>
            </header>

            {loading ? (
                <p className="font-inter text-sm text-neutral-400">loading...</p>
            ) : posts.length === 0 ? (
                <p className="font-inter text-sm text-neutral-400">no posts yet. write something.</p>
            ) : (
                <div className="flex flex-col gap-3">
                    {posts.map((post) => (
                        <div key={post._id} className="flex items-center justify-between py-4 border-b border-neutral-200">
                            <div>
                                <p className="font-inter text-sm font-medium">{post.title}</p>
                                <p className="font-inter text-xs text-neutral-400 mt-0.5">
                                    {new Date(post.createdAt).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })}
                                    {" · "}
                                    <span className={post.published ? "text-emerald-500" : "text-neutral-400"}>
                                        {post.published ? "published" : "draft"}
                                    </span>
                                </p>
                            </div>
                            <div className="flex gap-3">
                                <button
                                    onClick={() => handleTogglePublish(post)}
                                    className="font-inter text-xs text-neutral-500 hover:text-[#F4611D] transition-colors cursor-pointer"
                                >
                                    {post.published ? "unpublish" : "publish"}
                                </button>
                                <Link
                                    to={`${ADMIN_PATH}/edit/${post._id}`}
                                    className="font-inter text-xs text-neutral-500 hover:text-[#F4611D] transition-colors"
                                >
                                    edit
                                </Link>
                                <button
                                    onClick={() => handleDelete(post._id)}
                                    className="font-inter text-xs text-neutral-500 hover:text-red-500 transition-colors cursor-pointer"
                                >
                                    delete
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Dashboard;
